import React from "react";
import styled from "styled-components";

// Define the data for the companies
const companies = [
  {
    name: "Nvidia",
    logo: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        x="0"
        y="0"
        width="70px"
        version="1.1"
        viewBox="35.188 31.512 351.46 258.785"
        xmlSpace="preserve"
      >
        <path d="M384.195 282.109c0 3.771-2.769 6.302-6.047 6.302v-.023c-3.371.023-6.089-2.508-6.089-6.278 0-3.769 2.718-6.293 6.089-6.293 3.279-.001 6.047 2.523 6.047 6.292zm2.453 0c0-5.175-4.02-8.179-8.5-8.179-4.511 0-8.531 3.004-8.531 8.179 0 5.172 4.021 8.188 8.531 8.188 4.481 0 8.5-3.016 8.5-8.188m-9.91.692h.91l2.109 3.703h2.316l-2.336-3.859c1.207-.086 2.2-.661 2.2-2.286 0-2.019-1.392-2.668-3.75-2.668h-3.411v8.813h1.961v-3.703m.001-1.492v-2.122h1.364c.742 0 1.753.06 1.753.965 0 .985-.523 1.157-1.398 1.157h-1.719"></path>
        <path
          fill="WHITE"
          d="M329.406 237.027l10.598 28.993H318.48l10.926-28.993zm-11.35-11.289l-24.423 61.88h17.246l3.863-10.934h28.903l3.656 10.934h18.722l-24.605-61.888-23.362.008zm-49.033 61.903h17.497v-61.922l-17.5-.004.003 61.926zm-121.467-61.926l-14.598 49.078-13.984-49.074-18.879-.004 19.972 61.926h25.207l20.133-61.926h-17.851zm70.725 13.484h7.52c10.91 0 17.966 4.898 17.966 17.609 0 12.714-7.056 17.613-17.966 17.613h-7.52v-35.222zm-17.35-13.484v61.926h28.366c15.113 0 20.048-2.512 25.384-8.148 3.769-3.957 6.207-12.641 6.207-22.134 0-8.707-2.063-16.468-5.66-21.304-6.481-8.649-15.817-10.34-29.75-10.34h-24.547zm-165.743-.086v62.012h17.645v-47.086l13.672.004c4.527 0 7.754 1.128 9.934 3.457 2.765 2.945 3.894 7.699 3.894 16.395v27.23h17.098v-34.262c0-24.453-15.586-27.75-30.836-27.75H35.188zm137.583.086l.007 61.926h17.489v-61.926h-17.496z"
        ></path>
        <path
          fill="WHITE"
          d="M82.211 102.414s22.504-33.203 67.437-36.638V53.73c-49.769 3.997-92.867 46.149-92.867 46.149s24.41 70.565 92.867 77.026v-12.804c-50.237-6.32-67.437-61.687-67.437-61.687zm67.437 36.223v11.726c-37.968-6.769-48.507-46.237-48.507-46.237s18.23-20.195 48.507-23.47v12.867c-.023 0-.039-.007-.058-.007-15.891-1.907-28.305 12.938-28.305 12.938s6.958 24.991 28.363 32.183m0-107.125V53.73c1.461-.112 2.922-.207 4.391-.257 56.582-1.907 93.449 46.406 93.449 46.406s-42.343 51.488-86.457 51.488c-4.043 0-7.828-.375-11.383-1.005v13.739c3.04.386 6.192.613 9.481.613 41.051 0 70.738-20.965 99.484-45.778 4.766 3.817 24.278 13.103 28.289 17.168-27.332 22.883-91.031 41.329-127.144 41.329-3.481 0-6.824-.211-10.11-.528v19.306H305.68V31.512H149.648zm0 49.144V65.777c1.446-.101 2.903-.179 4.391-.226 40.688-1.278 67.382 34.965 67.382 34.965s-28.832 40.043-59.746 40.043c-4.449 0-8.438-.715-12.028-1.922V93.523c15.84 1.914 19.028 8.911 28.551 24.786l21.18-17.859s-15.461-20.277-41.524-20.277c-2.833-.001-5.544.198-8.206.483"
        ></path>
      </svg>
    ),
  },
  {
    name: "Telus",
    logo: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 220 45"
        version="1"
        width="180px"
      >
        <g transform="translate(-402.051 -487.003)">
          <g transform="matrix(.91092 0 0 .91092 386.124 484.338)">
            <path
              fill="WHITE"
              d="M160.391 17.903L160.391 13.057 143.104 13.057 143.104 37.99 160.391 37.99 160.391 32.933 150.103 32.933 150.103 27.406 158.66 27.406 158.66 22.566 150.103 22.566 150.103 17.903 160.391 17.903"
            ></path>
            <path
              fill="WHITE"
              d="M190.875 33.07L180.075 33.07 180.075 13.057 172.99 13.057 172.99 37.99 190.875 37.99 190.875 33.07"
            ></path>
            <path
              fill="WHITE"
              d="M247.939 22.559c-4.781-1.077-6.455-1.202-6.455-3.104 0-1.765 2.369-2.314 3.732-2.314 2.204 0 4.807.514 7.46 1.874l1.929-4.588c-2.719-1.482-6.207-2.099-9.562-2.099-6.593 0-11.017 2.675-11.203 7.89-.188 4.756 3.679 6.535 7.233 7.269 3.426.708 6.902 1.314 6.972 3.349.063 1.877-1.625 2.681-4.81 2.681-2.95 0-5.693-.948-8.495-2.122l-1.638 4.987c3.222 1.37 6.492 2.125 9.863 2.125 4.684 0 8.102-.731 10.618-3.093 1.744-1.622 2.315-3.58 2.315-5.449.004-3.941-2.453-6.161-7.959-7.406"
            ></path>
            <path
              fill="WHITE"
              d="M133.053 17.979L133.053 13.057 111.309 13.057 111.309 17.979 118.655 17.979 118.655 37.99 125.698 37.99 125.698 17.979 133.053 17.979"
            ></path>
            <path
              fill="WHITE"
              d="M215.047 13.057v15.841c0 1.241 0 1.584-.074 2.067-.228 1.51-1.69 2.386-4.024 2.417-1.728-.028-2.994-.539-3.583-1.442-.297-.464-.441-1.298-.441-2.63V13.057h-7.348V30.24c0 2.381.318 3.456 1.393 4.815 1.774 2.217 5.232 3.383 9.993 3.383h.261c6.375 0 9.668-2.486 10.619-4.812.475-1.128.51-1.662.51-3.938V13.057h-7.306"
            ></path>
            <path
              fill="WHITE"
              d="M114.628 6.23l-41.207 8.204v2.874l.131-.034c27.222-6.617 41.075-10.597 41.187-10.625.154-.04.208-.16.187-.261-.023-.106-.134-.194-.298-.158"
            ></path>
            <path
              fill="WHITE"
              d="M79.716 8.01v-.004.004m1.409-2.564c-2.003.114-5.712 3.081-7.748 4.843-8.107 7.014-14.135 13.461-18.518 20.213-9.137 4.894-20.788 9.927-32.354 13.855l-.279.094L20 50.445l1.271-.491c7.358-2.804 19.639-8.07 30.772-13.924-.627 1.672-.943 3.209-.943 4.61 0 1.045.175 2.017.524 2.9.7 1.764 2.08 3.1 3.993 3.859 2.849 1.137 6.736 1.158 11.171-.185 11.33-3.434 24.769-13.978 27.695-16.075l.112-.079c.115-.083.123-.208.075-.293-.064-.097-.199-.123-.31-.055h-.001.001l-.144.087c-3.14 1.885-18.398 10.944-28.316 13.604-5.052 1.355-8.902.615-10.354-1.416-.504-.694-.747-1.572-.747-2.596 0-1.999.941-4.544 2.753-7.373a124.653 124.653 0 004.63-2.759c9.676-5.438 20.824-16.011 21.3-22.465.002-.044.002-.095.002-.143 0-.557-.241-1.13-.664-1.553a2.14 2.14 0 00-1.695-.652zm-1.079 3.076c.635-.411.818-.154.631.31-.302.741-1.699 5.199-12.072 13.715-2.707 2.217-4.632 3.462-8.53 5.77 6.383-8.945 15.702-17.023 19.971-19.795z"
            ></path>
            <path
              fill="WHITE"
              d="M73.286 14.461L29.932 23.78 28.26 28.289 73.421 17.307 74.818 16.518 74.779 14.466 73.286 14.461"
            ></path>
          </g>
        </g>
      </svg>
    ),
  },
  {
    name: "Ability Matrix",
    logo: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 501 126"
        width="180px"
      >
        <path
          fill="WHITE"
          d="M62.87 125.03c34.54 0 62.54-27.982 62.54-62.5S97.41.03 62.87.03.33 28.012.33 62.53s28 62.5 62.54 62.5z"
        ></path>
        <path
          fill="BLACK"
          fillRule="evenodd"
          d="M30.6 25.18v4.76h10.18L17.72 92.25H12v5h21.28v-5h-9.6l6.92-20.37h29.72l7.5 20.37H58v5h21.62v-4.84h-3.54l21.18-62.47v62.47h-8.75v4.82h24.16v-4.82h-9.77V29.94h9.77v-4.76H93.32l-21 62.2-22.64-62.2H30.6z"
          clipRule="evenodd"
        ></path>
        <path
          fill="WHITE"
          fillRule="evenodd"
          d="M45.76 31.23L32.84 66.74h25.67L45.76 31.23z"
          clipRule="evenodd"
        ></path>
        <path
          fill="WHITE"
          d="M173.93 60.8l-8-21.82-8.1 21.82h16.1zm-28.8 18.35v-2.92h3.56L164 35.49h4.42l14.89 40.74h3.56v2.92h-13.41v-2.92h6L175 63.81h-18.29l-4.52 12.42h6v2.92M196.61 64.38A16.472 16.472 0 00199 73.6a7.999 7.999 0 007.2 3.67 7.578 7.578 0 007.13-4.08 20.21 20.21 0 002.27-9.94 15.002 15.002 0 00-2.44-8.88 8.192 8.192 0 00-7.16-3.45 7.692 7.692 0 00-7.06 4 18.241 18.241 0 00-2.37 9.44m-7.72 14.77V76.6h4.62V38h-4.62v-2.51h7.72v19.56h.09a10.746 10.746 0 013.91-4.85 10 10 0 015.79-1.8 12.561 12.561 0 017.13 1.9 11.006 11.006 0 014.17 5.35 22.817 22.817 0 011.34 8.16c0 4.76-1.067 8.617-3.2 11.57-2.13 3-5.26 4.44-9.42 4.44a9.999 9.999 0 01-5.71-1.58 12.18 12.18 0 01-4-4.93h-.09v5.84M231.83 41.71h-3.68v-4.62h3.68v4.62zm-9 37.44V76.6h6v-25h-6v-2.47h9V76.6h4.89v2.55M238.78 79.15V76.6h4.51V38h-4.51v-2.51h7.55V76.6h4.13v2.55M261.86 41.71h-3.67v-4.62h3.67v4.62zm-9 37.44V76.6h6v-25h-6v-2.47h9V76.6h4.9v2.55M285.76 49.13v2.45h-8.93v17.78a18.27 18.27 0 00.64 5.68 2.693 2.693 0 002.85 1.86 3.141 3.141 0 003.13-1.69c.641-1.648.921-3.414.82-5.18h2.91c0 3.23-.52 5.67-1.58 7.32-1.06 1.65-2.89 2.46-5.49 2.46-4.2 0-6.3-3.107-6.3-9.32V51.58h-5.08v-2.45h5.08V42l3-1.31v8.45M317.11 49.13v2.45h-2.36l-10.53 28.78c-1 2.76-1.74 4.71-2.23 5.84a9.802 9.802 0 01-2.25 3.16 5.307 5.307 0 01-3.82 1.46 35.894 35.894 0 01-4.23-.19V88a30.89 30.89 0 003.2.19 4.11 4.11 0 003.7-2.22 33.165 33.165 0 002.71-6.72L291 51.58h-2.35v-2.45H299v2.45h-4.59l8.46 23.62 8.66-23.62H307v-2.45M369.65 35.49v2.91h-6v37.83h6v2.92h-14.87v-2.92h5.45V38.4h-.09l-13.93 40.75h-3.1L329.27 38.4h-.2v37.83h5.37v2.92h-14.68v-2.92h6V38.4h-6v-2.91h11.86l13 38.31 13.11-38.31M376.68 70.4a6.49 6.49 0 002 5 6.91 6.91 0 004.87 1.86c3.333 0 5.77-1.27 7.31-3.81a18.922 18.922 0 002.29-9.83H387c-6.847 0-10.274 2.26-10.28 6.78m16.48 8.75v-6h-.2a9.154 9.154 0 01-3.94 5 11.6 11.6 0 01-6.13 1.68 9.87 9.87 0 01-6.93-2.46c-1.78-1.63-2.66-4-2.66-7.15a7.676 7.676 0 012.19-5.92 10.467 10.467 0 015.21-2.62c2.21-.405 4.453-.6 6.7-.58h5.75v-2.19c0-5.333-2.544-8-7.63-8-4.667 0-7.304 2.167-7.91 6.5h-3.37c.77-6 4.45-9 11-9 3.64 0 6.36.81 8.18 2.43 1.82 1.62 2.74 4.31 2.74 8.09V76.6h4.16v2.55M419.16 49.13v2.45h-8.94v17.78c-.076 1.915.14 3.83.64 5.68a2.698 2.698 0 002.85 1.86 3.158 3.158 0 003.14-1.69c.637-1.649.913-3.415.81-5.18h2.93c0 3.227-.53 5.667-1.59 7.32-1.06 1.653-2.893 2.473-5.5 2.46-4.187 0-6.283-3.107-6.29-9.32V51.58h-5.08v-2.45h5.08V42l3-1.31v8.45M422.53 79.15V76.6H427v-25h-4.44v-2.47h7.54v5.92h.1a9.067 9.067 0 012.62-4.83 6.522 6.522 0 014.61-1.83c.735-.017 1.469.046 2.19.19v3c-1-.11-1.74-.18-2.19-.18-4.88 0-7.323 4.137-7.33 12.41V76.6h5.9v2.55M451.82 41.71h-3.68v-4.62h3.68v4.62zm-9 37.44V76.6h6v-25h-6v-2.47h9V76.6h4.9v2.55M458.3 79.15V76.6h2.64l10-12.89-9.31-12.13h-2.73v-2.45h10.91v2.45h-4.23l7.24 9.61 7.45-9.61H476v-2.45h10.73v2.45h-2.83l-9.12 12.13 9.79 12.89h2.83v2.55h-10.82V76.6h4.22l-8-10.43-7.91 10.43h4.24v2.55M492.81 36.72v3.35H494c.37.005.739-.032 1.1-.11.303-.076.571-.252.76-.5.22-.341.322-.745.29-1.15a1.728 1.728 0 00-.26-1.06 1.158 1.158 0 00-.72-.44 5.319 5.319 0 00-1.17-.09h-1.19zm-1.62 7.52v-.54h1v-7h-1v-.54h2.7a7.314 7.314 0 011.51.13c.391.084.742.295 1 .6a2.646 2.646 0 010 2.85 2.096 2.096 0 01-1.21.59c.206.056.404.137.59.24a.863.863 0 01.27.37c.137.327.257.66.36 1l.59 1.76h.59v.54h-1.13l-.7-2.38a4.93 4.93 0 00-.3-.85.663.663 0 00-.41-.31 3.657 3.657 0 00-1-.09h-1.25v3.09h1v.54h-2.61z"
        ></path>
        <path
          fill="WHITE"
          d="M494.21 34.73a5.632 5.632 0 00-5.522 6.728 5.633 5.633 0 007.677 4.103 5.628 5.628 0 003.475-5.201 5.648 5.648 0 00-5.63-5.63zm0 11.76a6.13 6.13 0 11-.02-12.26 6.13 6.13 0 01.02 12.26z"
        ></path>
      </svg>
    ),
  },

  // Add more companies as needed
];

// Define the Banner component
const CompanyBanner = () => {
  return (
    <BannerContainer>
      <BannerText>
        <h2>Join Members From Companies Like</h2>
      </BannerText>
      <CompanyCardContainer>
        {companies.map((company, index) => (
          <CompanyCard key={index}>{company.logo}</CompanyCard>
        ))}
      </CompanyCardContainer>
    </BannerContainer>
  );
};

const BannerContainer = styled.div`

  justify-content: center;
  background-color: black;
  padding: 20px 8px;
  gap: 0px;
  flex-direction: column;
  width: 100%;
`;

const BannerText = styled.div`
  display: flex;
  align-items: end;
  justify-content: center;
  text-align: center;
  width: 100%;
  color: white;

  h2 {
    padding: 0;
    margin: 0;

  }
`;

const CompanyCardContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  margin: 20px;
`;

const CompanyCard = styled.div`
  height: 32px;
  min-width: 80px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px;
  border-radius: 10px;
  text-align: center;


  div {
    padding: 10px;
  }

  svg {
  }
`;

const Logo = styled.img`
  // max-width: 80px; /* Reduced max-width */
  // height: auto; /* Maintain aspect ratio */
`;

export default CompanyBanner;
